import { useState } from "react";
import endpoint from "./Axios";
import endpointSettingsApi from "./AxiosSettingsApi";

const useForgoCardsAxios = ({ api, method, payApi }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const reset = () => {
    setData(null);
    setLoading(false);
  };

  const onCall = async ({ data, headers, params }) => {
    setLoading(true);
    console.log({ params });
    try {
      let result;
      if (method === "get")
        result = payApi === 'settings' ? await endpointSettingsApi[method](api, { headers, params }) : await endpoint[method](api, { headers, params });
      else
        result = payApi === 'settings' ? await endpointSettingsApi[method](api, data, { headers, params }) : await endpoint[method](api, data, { headers, params });
      setLoading(false);
      setData(result.data);
      return Promise.resolve(result.data);
    } catch (err) {
      setLoading(false);
      setData(err);
      return Promise.reject(err);
    }
  };

  return {
    loading,
    data,
    reset,
    onCall,
  };
};

export default useForgoCardsAxios;